import { GetActivityQuery, GetActivityMsg } from '../autogenerated/ZoomBridge';
import Storage from '../protocol/Storage';
import BackgroundJobRunner from '../util/runner/BackgroundJobRunner';
import Store from '../store/Store';
import { NOTIFICATION_INFO } from '../store/Constants';

export default class NotificationController {
  static instance = null;
  static timerGap = 1000 * 30;
  static activityInfoLatestTime = 'activityInfoLatestTime';

  constructor() {
    if (NotificationController.instance === null) {
      NotificationController.instance = this;
      BackgroundJobRunner.JOB_RUNNER.addJob('GetActivity Query', () => {
        this.onTimerComplete();
      });
    }
    return NotificationController.instance;
  }

  static getInstance() {
    if (NotificationController.instance === null) {
      NotificationController.instance = new NotificationController();
    }
    return NotificationController.instance;
  }

  addTimer() {
    // this.timer = setInterval(this.onTimerComplete, NotificationController.timerGap);
  }

  onTimerComplete() {
    NotificationController.getInstance().checkToExecuteQuery();
  }

  clearTimer() {
    //if (this.timer)
    //  clearTimeout(this.timer);
  }

  resetTimer() {
    // this.clearTimer();
    // this.addTimer();
  }

  issueImmediateQuery() {
    this.checkToExecuteQuery();
  }

  checkToExecuteQuery() {
    if (this.sendingQuery) return;
    let activityPanelMtime = Storage.get(NotificationController.activityInfoLatestTime);
    const notificationMtime = window.gs.notificationInfo.latestTime;
    const currentTime = new Date().getTime();

    if (!activityPanelMtime) {
      activityPanelMtime = !notificationMtime ? currentTime : notificationMtime;
    }

    if (!notificationMtime) {
      this.sendQuery(activityPanelMtime);
    } else {
      this.sendQuery(Math.max(activityPanelMtime, notificationMtime));
    }
  }

  sendQuery(mTime) {
    this.sendingQuery = true;
    // this.clearTimer();
    const getActivityQuery = new GetActivityQuery();
    const msg = new GetActivityMsg();

    if (window.gs.notificationInfo.onlyNotifications) msg.setOnlyNotifications(true);
    if (window.gs.notificationInfo.onlyTasks) msg.setOnlyTasks(true);
    if (window.gs.notificationInfo.onlyComments) msg.setOnlyComments(true);

    msg.setMtime(mTime);
    msg.setSkipActivityFromCurrentUser(true);
    getActivityQuery.message = msg;
    getActivityQuery.run().then(
      (resp) => {
        this.onResponseReceived(resp);
      },
      (error) => {
        // this.addTimer();
        //ErrorHandler.handleError(error);
        this.sendingQuery = false;
      }
    );
  }

  onResponseReceived(resp) {
    if (window.gs.notificationInfo.latestTime == window.gs.activityInfo.latestTime) {
      window.gs.notificationInfo.activities = resp.getActivityList();
    } else {
      if (!_.isEmpty(resp.getActivityList())) {
        if (!window.gs.notificationInfo.activities) window.gs.notificationInfo.activities = [];

        if (
          !_.isEmpty(window.gs.notificationInfo.activities) &&
          window.gs.notificationInfo.latestTimeDateLabel &&
          window.gs.notificationInfo.latestTimeDateLabel == resp.getLatestTimeDateLabel()
        ) {
          const item = window.gs.notificationInfo.activities.shift();
          item.setDateLabel(null);
          window.gs.notificationInfo.activities.unshift(item);
        }

        _.eachRight(resp.getActivityList(), (__activity) => {
          window.gs.notificationInfo.activities.unshift(__activity);
        });
      }
    }

    if (!window.gs.notificationInfo.latestTime || window.gs.notificationInfo.latestTime < resp.getLatestTime()) {
      window.gs.notificationInfo.latestTime = resp.getLatestTime();
      window.gs.notificationInfo.latestTimeDateLabel = resp.getLatestTimeDateLabel();
    }

    // this.addTimer();
    this.sendingQuery = false;
    Store.put(NOTIFICATION_INFO, window.gs.notificationInfo);
  }
}
